// extracted by mini-css-extract-plugin
export default {"popup":"DeleteGuestPopup_popup__s3OXQ","btns":"DeleteGuestPopup_btns__UKf2J","submitting":"DeleteGuestPopup_submitting__aDRHf"};